// extracted by mini-css-extract-plugin
export default {"select":"CalendarSelect_select__b-Kzw","selectText":"CalendarSelect_selectText__TC6GZ"};